import React from "react";

// A block of "label · value" rows, used by the Spa and Network sections.
export const SpecGroup = ({ children }: { children: React.ReactNode }) => (
    <div className="sd-spec">
        <dl className="sd-spec-rows">{children}</dl>
    </div>
);

export const SpecRow = ({ label, children, mono }: { label: string; children: React.ReactNode; mono?: boolean }) => (
    <div className="sd-spec-row">
        <dt>{label}</dt>
        <dd className={mono ? 'mono' : ''}>{children}</dd>
    </div>
);
